import React, { Component } from "react";
import {checkUserName, checkSupporter} from '../lib/requests';
import {
  InputControl,
  validateRequired,
  validateEmail,
  validateEmailStartPeriods,
  validateEmailEndPeriods,
  validateEmailDoublePeriods,
  validateIsInt,
  validateExactLength,
  Message
} from "wvus-forms";
import { triggerAnalyticsEvent} from '../lib/analytics-helpers';

import {UNEXPECTED_ERROR, EXISTING_VALID_ACCOUNT, FALLACIOUS_EMAIL, EXISTING_EMAIL, INVALID_ACCOUNT_NUMBER_ERROR, INVALID_ACCOUNT_ZIP_ERROR} from '../lib/messages';

class AccountVerificationForm extends Component {
  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleEmailValueChange = this.handleEmailValueChange.bind(this);
    this.handleAccountValueChange = this.handleAccountValueChange.bind(this);
    this.handleZipValueChange = this.handleZipValueChange.bind(this);
    this.canBeSubmitted = this.canBeSubmitted.bind(this);
    this.toggleEmailSection = this.toggleEmailSection.bind(this);
    this.state = {
      hasError: false,
      errorMessage: "",
      loading: false,
      showEmailSection: false,
      verifyBy: "",
      showAccountVerificationForm: true
    };
  }

  getLoginURL(email = "", message = "", error = false) {
    const wv_error = error === true ? '&wv_error=true' : '';
    return `/login?wv_email=${email}&wv_message=${message}&wv_source=createAccount${wv_error}`;
  }

  toggleEmailSection() {
    const newState = !this.state.showEmailSection;
    this.setState({ showEmailSection: newState });

    if (newState) {
      triggerAnalyticsEvent({
        event_label: 'email_section_expanded'
      }, "account_lookup");
    }
  }

  handleverifyAccountByEmailResponse(response) {
    if (response.success) {
      if (response.ciam_account_exists && response.supporter_account_exists) {
        const email = this.props.formMethods.getFieldState("wv-create-account-form-user").value;
        const errorMessage = EXISTING_VALID_ACCOUNT;
        window.location.href = this.getLoginURL(email, errorMessage);
        return;
      }

      if (!response.ciam_account_exists && response.supporter_account_exists ) {
        this.LoadCreateCIAMAccountForm();
        return;
      }

      if (response.ciam_account_exists && !response.supporter_account_exists ) {
        this.setState({
          hasError: true,
          errorMessage: FALLACIOUS_EMAIL,
          loading: false,
        });
        return;
      }

      this.LoadCreateSupporterForm();
      return;
    } else {
      throw new Error(UNEXPECTED_ERROR);
    }
  }

  LoadCreateSupporterForm() {
    this.props.setForm("CreateSupporter", this.props.formMethods.getFieldState("wv-create-account-form-user").value);
  }

  LoadCreateCIAMAccountForm() {
    this.props.setForm("CreateCiamAccount", this.props.formMethods.getFieldState("wv-create-account-form-user").value);
  }

  handleverifyAccountBySupporterNumberResponse(response) {
    if (response.success) {
      if (response.ciam_account_exists) {
        const message = EXISTING_EMAIL(response.supporter_email) ;
        window.location.href = this.getLoginURL("", message);
        return;
      }

      if (!response.supporter_account_exists) {
        const errorMessage = INVALID_ACCOUNT_NUMBER_ERROR;

        triggerAnalyticsEvent({
          event_label:'create_account',
          error_message: errorMessage
        }, "create_account_error");

        this.setState({ hasError: true, errorMessage, loading: false });
        return;

      } else {
        if(!response.is_valid_zip) {
          const errorMessage = INVALID_ACCOUNT_ZIP_ERROR;

          triggerAnalyticsEvent({
            event_label:'create_account',
            error_message: errorMessage
          }, "create_account_error");

          this.setState({ hasError: true, errorMessage, loading: false });
          return;
        }

        this.props.setForm(
          "CreateCiamAccountBySupporterNumber",
          response.supporter_email,
          this.props.formMethods.getFieldState("supporter-number").value
        );
        return;
      }
    } else {
      triggerAnalyticsEvent({
        event_label:'create_account',
        error_message: 'Unexpected error'
      }, "create_account_error");
      throw new Error(UNEXPECTED_ERROR);
    }
  }

  handleFormSubmit(e) {
    e.preventDefault();

    this.setState({ loading: true });

    // fail safe to bail if they get around disabled button
    if (!this.canBeSubmitted()) return false;
    const wp_nonce = window.wvusApiSettings.nonce;

    if( this.state.verifyBy === 'email' ) {
      const email = this.props.formMethods.getFieldState("wv-create-account-form-user").value;
      checkUserName(email, wp_nonce)
      .then(response => {
        if(!response.data) {
          throw new Error();
        }
        this.handleverifyAccountByEmailResponse(response.data);
      })
      .catch(error => {
        const errorMessage = UNEXPECTED_ERROR;
        this.setState({ hasError: true, errorMessage, loading: false });
      });
    } else if( this.state.verifyBy === 'account' ) {
      const supporter_number = this.props.formMethods.getFieldState("supporter-number").value;
      const zip = this.props.formMethods.getFieldState("zip-code").value;

      checkSupporter(supporter_number, zip, wp_nonce)
        .then(response => {
          if(!response.data) {
            throw new Error();
          }
          this.handleverifyAccountBySupporterNumberResponse(response.data);
        })
      .catch(error => {
        const errorMessage = UNEXPECTED_ERROR;
        this.setState({ hasError: true, errorMessage, loading: false });
      });

    } else {
      const errorMessage = UNEXPECTED_ERROR;
      this.setState({ hasError: true, errorMessage, loading: false });
    }
  }

  canBeSubmitted() {
    const email = this.props.formMethods.getFieldState("wv-create-account-form-user").value;

    const isEmailValid = this.props.formMethods.getFieldState("wv-create-account-form-user").isValid;

    const supporter_number = this.props.formMethods.getFieldState("supporter-number").value;
    const zip = this.props.formMethods.getFieldState("zip-code").value;

    const isAccountInfoValid = this.props.formMethods.getFieldState("supporter-number").isValid &&
                                  this.props.formMethods.getFieldState("zip-code").isValid;

    return (email !== undefined && email.length > 0 && isEmailValid) ||
            (supporter_number !== undefined && supporter_number.length > 0 &&
              zip !== undefined && zip.length > 0 &&
              isAccountInfoValid);
  }

  handleEmailValueChange = e => {
    this.setState({
      errorMessage: "",
      hasError: false,
      verifyBy: 'email'
    });
    this.props.formMethods.resetField("supporter-number");
    this.props.formMethods.resetField("zip-code");
    this.props.formMethods.handleValueChange(e);
  };
  handleAccountValueChange = e => {
    this.setState({
      errorMessage: "",
      hasError: false,
      verifyBy: 'account'
    });
    this.props.formMethods.resetField("wv-create-account-form-user");
    this.props.formMethods.handleValueChange(e);
  };
  handleZipValueChange = e => {
    this.props.formMethods.resetField("wv-create-account-form-user");
    this.props.formMethods.handleValueChange(e);
  };

  render() {
    const { loading, showEmailSection } = this.state;
    const { formMethods } = this.props;
    const errorMessage = this.state.hasError ? (
      <p className="wv-create-account-error-message error-message" role="alert" aria-live="assertive">
      {this.state.errorMessage}
      </p>
    ) : (
      ""
    );

    const loadingIcon = loading ? (
      <span>
      <i className="fa fa-spinner fa-pulse fa-fw" />
      <span className="sr-only">Loading...</span>
      </span>
    ) : (
      ""
    );
    const submitDisabled = !this.canBeSubmitted() || loading;

    return (
      <form
        id="wv-create-account-verification-form"
        className="wv-create-account-verification-form wvus-form"
      >
        <div className="create-account__error-banner">
          {errorMessage}
        </div>

        <div className="snackbar" role="status" aria-live="polite">
          <div className="snackbar-content">
            <div className="snackbar-icon-text">
              <div className="snackbar-icon">
                <i className="fa fa-info-circle" aria-hidden="true" />
              </div>
              <div className="snackbar-text">
                <p className="snackbar-body">
                  Your account number is the 9-digit number (XXXXXXXXX) on the welcome letter you received in the mail. It appears in the top-left corner.
                </p>
              </div>
            </div>
          </div>
        </div>

        <InputControl
          fieldId="supporter-number"
          fieldName="supporter-number"
          fieldTitle="Account number"
          fieldType="text"
          fieldClasses="create-account__input"
          fieldPlaceholder="9-digit number, no dashes"
          formMethods={formMethods}
          validators={[validateIsInt]}
          handleValueChange={this.handleAccountValueChange}
        />

        <InputControl
          fieldId="zip-code"
          fieldName="zip-code"
          fieldTitle="Zip code"
          fieldType="text"
          fieldClasses="create-account__input"
          fieldPlaceholder="12345"
          formMethods={formMethods}
          validators={[validateIsInt, validateExactLength(5)]}
          handleValueChange={this.handleZipValueChange}
        />

        <div className="create-account__divider">
          <span className="create-account__divider-text">or</span>
        </div>

        <button
          type="button"
          className="create-account__toggle"
          onClick={this.toggleEmailSection}
          aria-expanded={showEmailSection}
          aria-controls="email-section"
        >
          <span>Don't have your account number?</span>
          <i className="fa fa-chevron-down" aria-hidden="true" />
        </button>

        <div
          id="email-section"
          className={`create-account__expandable${showEmailSection ? ' create-account__expandable--open' : ''}`}
        >
          <div className="create-account__expandable-inner">
            <InputControl
              fieldId="wv-create-account-form-user"
              fieldName="wv-create-account-form-user"
              fieldTitle="Email address"
              fieldType="email"
              fieldClasses="create-account__input"
              placeholder="you@example.com"
              formMethods={formMethods}
              validators={[validateEmailStartPeriods, validateEmailEndPeriods, validateEmailDoublePeriods, validateEmail]}
              handleValueChange={this.handleEmailValueChange}
            />
          </div>
        </div>

        <button
          type="submit"
          id="wv-create-account-form-submit"
          className="btn btn-medium btn-primary create-account__submit"
          disabled={submitDisabled}
          onClick={this.handleFormSubmit}
        >
          {loadingIcon} Continue
        </button>

      </form>
    );
  }
}
export { AccountVerificationForm };
